import { ErrorState } from './FeedbackStates';
import { getApiErrorDescription } from './errorMessages';

export function ApiErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return <ErrorState description={getApiErrorDescription(error)} onRetry={onRetry} />;
}
